import { render, staticRenderFns } from "./CommitmentLetter.vue?vue&type=template&id=35225882&scoped=true"
import script from "./CommitmentLetter.vue?vue&type=script&lang=js"
export * from "./CommitmentLetter.vue?vue&type=script&lang=js"
import style0 from "./CommitmentLetter.vue?vue&type=style&index=0&id=35225882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35225882",
  null
  
)

export default component.exports